import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const searchAddressForLocalityGuard: CanActivateFn = (route) => {
  const router = inject(Router);

  const formData = JSON.parse(route.queryParams['addrSearchFormData']);

  if (formData?.locality) {
    return true;
  } else {
    return router.createUrlTree(['/map']);
  }
};
